"use strict";

var R, _shorten2, shorten;

R = require('ramda');

shorten = function shorten(text, max, appendEllipsis) {
  var res;
  res = R.join(" ", _shorten2([], 0, max, text.split(/\s+/)));
  if (res.length < text.length && appendEllipsis) {
    return res + "...";
  } else {
    return res;
  }
};

_shorten2 = function _shorten(acc, accSize, max, words) {
  var word;
  if (words.length === 0) {
    return acc;
  }
  word = R.head(words);
  if (accSize + word.length < max) {
    return _shorten2(R.append(word, acc), accSize + word.length + 1, max, R.tail(words));
  } else {
    return acc;
  }
};

module.exports = {
  shorten: shorten
};